import React from 'react';

export const AI_EVAL_SCORE_TOOLTIP =
  'AI Eval is not derived from averaging scores. It also weighs intent, plagiarism checks, and your behaviour toward the interviewer.';

const AiEvalScoreLabel: React.FC = () => (
  <div className="ai-eval-score-label-row">
    <p className="ai-eval-score-label-text">AI Eval Score</p>
    <button
      type="button"
      className="feedback-ai-eval-info-btn"
      aria-label={AI_EVAL_SCORE_TOOLTIP}
      data-tooltip={AI_EVAL_SCORE_TOOLTIP}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4M12 8h.01" strokeLinecap="round" />
      </svg>
    </button>
  </div>
);

export default AiEvalScoreLabel;
